import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, WithRouterProps } from 'react-router';

import { GlobalState } from 'ha/types/store';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { getCurrentLanguageCode, getCurrentPageLanguages } from '../selectors';
import changeLanguage from '../actions/changeLanguage';
import LanguageSwitcher from '../components/LanguageSwitcher';

export default compose(
  withRouter,
  connect(
    (state: GlobalState, props: WithRouterProps) => ({
      selected: getCurrentLanguageCode(state),
      languages: getCurrentPageLanguages(state, props.location),
      isAuthenticated: getIsAuthenticated(state),
    }),
    {
      onChangeLanguage: changeLanguage,
    },
  ),
)(LanguageSwitcher);
